import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs, useStore } from "@nuxtjs/composition-api";

import { useFeatureDetection, useLinkService } from "@/composables";
import { useCartsStore } from "@/store";
import { getProductDetailsStore } from "@/store/product-details";
import { type CartItemPreview } from "@/types/components/CartsListItem";
import { filterRemoveUndefined } from "@/utils/transform/array";


export default /*#__PURE__*/_defineComponent({
  __name: 'CartsListItem',
  props: {
  id: {
    type: String,
    required: true,
  },
  retailerName: {
    type: String,
    default: "",
  },
  retailerImageUrl: {
    type: String,
    default: "",
  },
  itemCount: {
    type: String,
    default: "",
  },
  subtotal: {
    type: String,
    default: "",
  },
},
  emits: ["delete", "view"],
  setup(__props, { emit }: { emit: ({
  (e: "delete", cartId: string): void;
  (e: "view", cartId: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const MAX_PREVIEW_COUNT = 5;





const store = useStore();
const cartsStore = useCartsStore();
const productDetailsStore = getProductDetailsStore(store);
const { id, retailerName, retailerImageUrl, itemCount, subtotal } = toRefs(props);

const featureDetection = useFeatureDetection();
const linkService = useLinkService();

const imageProps = computed(() => {
  if (!retailerImageUrl.value) {
    return null;
  }
  const imageUrl = linkService.getImageLink({
    url: retailerImageUrl.value,
    width: "48",
    height: "48",
    useDefaultDpr: false,
  });
  return {
    src: imageUrl + `&dpr=${featureDetection.dpr}`,
    srcSet: `${imageUrl}&dpr=1 1x, ${imageUrl}&dpr=2 2x, ${imageUrl}&dpr=3 3x`,
    width: 48,
    height: 48,
    crossorigin: false,
    rounded: true,
  };
});

const cartItemPreviews = computed(() => {
  const cartItemIds = cartsStore.carts[id.value]?.cartItemIds ?? [];
  const cartItems = cartItemIds.map((cartItemId) => cartsStore.cartItems[cartItemId]).filter(filterRemoveUndefined);

  const previews: CartItemPreview[] = cartItems.map((cartItem) => ({
    id: cartItem.id,
    imageUrl: linkService.getImageLink({
      url: productDetailsStore.productDetails[cartItem.productDetailsId]?.imageUrl ?? "",
      width: "56",
      height: "56",
      useDefaultDpr: true,
    }),
  }));

  // If previews exceed the max preview count then, replace the last preview with a count of additional previews.
  if (previews.length > MAX_PREVIEW_COUNT) {
    const removedPreviews = previews.splice(MAX_PREVIEW_COUNT - 1);
    previews.push({
      id: `additional-products-${removedPreviews.length}`,
      count: removedPreviews.length,
    });
  }
  return previews;
});

const onDeleteCart = () => {
  emit("delete", id.value);
};

const onViewCart = () => {
  emit("view", id.value);
};

return { __sfc: true,MAX_PREVIEW_COUNT, emit, props, store, cartsStore, productDetailsStore, id, retailerName, retailerImageUrl, itemCount, subtotal, featureDetection, linkService, imageProps, cartItemPreviews, onDeleteCart, onViewCart }
}

})